import * as React from 'react';
import './styles.css';

export interface Props {
  logoCollapsed: boolean;
}
export const Logo: React.SFC<Props> = (props) => {
  return (
    <div className="logo">
      <div className="logo__text" >
        {props.logoCollapsed ? 'C v P' : 'Charlotte von Poehl'}
      </div>
    </div>);

};

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo/Component.tsx